import { getColumnsByNames } from './all-top10-columns-config';

export const topBlockedCountriesWithPercentReportConfig = getColumnsByNames([
    { name: 'country' },
    { name: 'count', width: '40%' },
    { name: 'percentOfTotal', header: '% Blocked Countries', width: '152px'}
]);